import React, { useState } from 'react';
import { Table } from 'react-bootstrap';

import { IRequester, deleteRequesterAPI } from 'src/services/api/frontLine';
import RequesterTableRow from './RequesterTableRow';
import ConfirmationBox from 'src/components/ConfrimationBox';
import * as noty from 'src/utils/noty';
import { IRequesterFilters } from '../RequesterList';
interface IRequesterTableProps {
  page: number;
  size: number;
  requesterList: IRequester[];
  isLoaded: boolean;
  fetchRequesterList: (
    filters: IRequesterFilters,
    page: number,
    size: number
  ) => void;
  filter: IRequesterFilters;
}
const RequesterTable: React.FC<IRequesterTableProps> = props => {
  const [showDeleteModal, setDeleteModal] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<string>('');

  const toggleDeleteModal = (id?: string) => {
    if (id) {
      setDeleteId(id);
    }
    setDeleteModal(!showDeleteModal);
  };

  const requesterDelete = async () => {
    try {
      await deleteRequesterAPI(deleteId);
      noty.success('Requester deleted successfully');
      toggleDeleteModal();
      let newPage = props.page;
      if (props.requesterList.length === 1 && props.page > 1) {
        newPage -= 1;
      }
      props.fetchRequesterList(props.filter, newPage, props.size);
    } catch (e) {
      noty.error('Failed to delete requester');
      console.log(e);
    }
  };

  return (
    <>
      <Table style={{ tableLayout: 'fixed' }}>
        <thead>
          <tr>
            <th>S.No.</th>
            <th>Name </th>
            <th>Email</th>
            <th>Organization</th>
            <th>Contact No</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {props.isLoaded ? (
            props.requesterList.length > 0 ? (
              props.requesterList.map((requester, index: number) => {
                const ind = (props.page - 1) * props.size + index;
                return (
                  <RequesterTableRow
                    key={requester._id}
                    index={ind}
                    requester={requester}
                    toggleDeleteModal={toggleDeleteModal}
                  />
                );
              })
            ) : (
              <tr>
                <td>No records found</td>
              </tr>
            )
          ) : (
            <tr>
              <td>Loading...</td>
            </tr>
          )}
        </tbody>
      </Table>
      {showDeleteModal && (
        <ConfirmationBox
          handleDelete={requesterDelete}
          toggleModal={toggleDeleteModal}
          showModal={showDeleteModal}
        >
          Are you sure?
        </ConfirmationBox>
      )}
    </>
  );
};
export default RequesterTable;
